import { render, staticRenderFns } from "./BCDDetails.vue?vue&type=template&id=701e0c3b"
import script from "./BCDDetails.vue?vue&type=script&lang=js"
export * from "./BCDDetails.vue?vue&type=script&lang=js"
import style0 from "./BCDDetails.vue?vue&type=style&index=0&id=701e0c3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports